import wayside from '../assets/images/sculpture-wayside-2024.webp'
import waysideBack from '../assets/images/sculpture-wayside-back-2024.webp'
import waysideDetail from '../assets/images/sculpture-wayside-detail-2024.webp'
import untitled from '../assets/images/sculpture-untitled-2024.webp'
import overpass from '../assets/images/sculpture-overpass-2024.webp'
import holdingHands from '../assets/images/sculpture-holding-hands-2024.webp'
import sundown from '../assets/images/sculpture-sundown-2024.webp'

import kingdomGlass from '../assets/images/sculpture-kingdom-glass-2023.webp'
import scum from '../assets/images/sculpture-scum-2023.webp'
import sailboat from '../assets/images/sculpture-sailboat-2023.webp'
import deathMachine from '../assets/images/sculpture-death-machine-2023.webp'
import againstI from '../assets/images/sculpture-against-i-2023.webp'
import reflexes1 from '../assets/images/sculpture-reflexes1-2023.webp'
import reflexes2 from '../assets/images/sculpture-reflexes2-2023.webp'
import bellies from '../assets/images/sculpture-bellies-eyes-2023.webp'
import peakingDawn from '../assets/images/sculpture-peaking-dawn-2023.webp'
import driftwood1 from '../assets/images/sculpture-driftwood1-2023.webp'
import driftwood2 from '../assets/images/sculpture-driftwood2-2023.webp'

import raft from '../assets/images/sculpture-raft-2022.webp'
import port from '../assets/images/sculpture-port-at-night-2022.webp'

export const sculptureImages = [
    {
        src: untitled,
        alt: "Untitled woodwork sculptural piece",
        title: "Untitled",
        dimension: '11.5" x 15"',
        material: "Acrylic, pencil, glitter, screws, cardoard, wood, uv print, engraving on OSB",
        year: "2024"
    },
    {
        src: overpass,
        alt: "",
        title: "Overpass",
        dimension: '10" x 11.5"',
        material: "Acrylic pastel, charcoal on paper pulp, found wood",
        year: "2024"
    },
    {
        src: sundown,
        alt: "",
        title: "Sundown",
        dimension: '6" x 7"',
        material: "Acrylic, soft & oil pastel on paper pulp and wood",
        year: 2024
    },
    {
        src: holdingHands,
        alt: "",
        title: "Holding hands",
        dimension: '15.5" x 9.5"',
        material: "Acrylic, soft & oil pastel, staples on wood",
        year: 2024
    },
    {
        src: againstI,
        alt: "",
        title: "Against I",
        dimension: '7" x 9" x 2"',
        material: "Acrylic, soft & oil pastel on paper pulp",
        year: "2023"
    },
    {
        src: kingdomGlass,
        alt: "",
        title: "Kingdom of Glass",
        dimension: '6" x 5"',
        material: "Acrylic, screws, soft & oil pastel on cardboard, paper pulp and wood",
        year: 2023
    },
    {
        src: deathMachine,
        alt: "",
        title: "Death of the Machine",
        dimension: '6" x 7.5"',
        material: "Acrylic, screws, staples, soft & oil pastel on cardboard, paper pulp and wood",
        year: "2023"
    },
    {
        src: sailboat,
        alt: "",
        title: "Sailboat",
        dimension: '7.5" x 7"',
        material: "Acrylic, oil pastel and staples on found wood",
        year: "2023"
    },
    {
        src: peakingDawn,
        alt: "",
        title: "Peaking dawn",
        dimension: '4.5" x 11.5"',
        material: "Acrylic, soft & oil pastel on paper pulp and wood",
        year: "2023"
    },
    {
        src: bellies,
        alt: "",
        title: "As it bellies before our eyes",
        dimension: '7" x 7"',
        material: "Acrylic, glitter, soft & oil pastel on hanji, cardboard, paper pulp and foam board",
        year: "2023"
    },
    {
        src: scum,
        alt: "",
        title: "Scum",
        dimension: '5" x 7"',
        material: "Acrylic, color pencil, soft & oil pastel on hanji, paper pulp and wood",
        year: "2023"
    },
    {
        src: reflexes1,
        alt: "",
        title: "Reflexes I",
        dimension: '7" x 7"',
        material: "Acrylic, soft & oil pastel on hanji, staples, cardboard and wood",
        year: "2023"
    },
    {
        src: reflexes2,
        alt: "",
        title: "Reflexes II",
        dimension: '7" x 7"',
        material: "Acrylic, soft & oil pastel on hanji, staples, cardboard and wood",
        year: "2023"
    },
    {
        src: driftwood1,
        alt: "",
        title: "Driftwood 1",
        dimension: '18" x 3"',
        material: "Oil pastel on found wood",
        year: "2023"
    },
    {
        src: driftwood2,
        alt: "",
        title: "Driftwood 2",
        dimension: '17" x 3"',
        material: "Oil pastel on found wood",
        year: "2023"
    },
    {
        src: port,
        alt: "",
        title: "Port at night",
        dimension: '7" x 7"',
        material: "Oil and ink on found wood",
        year: "2022"
    },
    {
        src: raft,
        alt: "",
        title: "Raft",
        dimension: '12" x 18"',
        material: "Soft pastel, charcoal and string on cardboard",
        year: "2022"
    }

]

export const sculptureSeries = [
    {
        category: "sculpture",
        id: "wayside-returns-series",
        cover: wayside,
        title: "Wayside Re-turns (The donkey's path)",
        dimension: '22.5" x 17.5" x 9"',
        material: "Acrylic, glitter, charcoal, gesso, rope, figurine on cardboard, found wood, OSB",
        year: "2024",
        description: `Wayside Re-turns is an exploration of architectural forms in collage and collapse: their complacencies,
        social-bindings, and emotional effect to the human eye. Its sense of direction is sprawling, desolate, and still. Despite this,
        our present day may very well reflect the philosophy of purpose, time, and progress shared by the Donkey Rider, an icon commonly
        found in classical Chinese landscape painting, whose journey is guaranteed and destination forthcoming. The path winding into
        obscurity, the future unclear and the mountain fading out of sight. Ahead is an obsolete stage with yet a playfully autonomous
        donkey, and perhaps us as its un(fore)seen rider.`,
        images: [
            {
                src: wayside,
                alt: "",
                title: "Wayside Re-turns (The donkey's path)",
                dimension: '22.5" x 17.5" x 9"',
                material: "Acrylic, glitter, charcoal, gesso, rope, figurine on cardboard, found wood, OSB",
                year: "2024",
            },
            {
                src: waysideBack,
                alt: "",
                title: "Wayside Re-turns (The donkey's path)",
                dimension: '22.5" x 17.5" x 9"',
                material: "Acrylic, glitter, charcoal, gesso, rope, figurine on cardboard, found wood, OSB",
                year: "2024",
            },
            {
                src: waysideDetail,
                alt: "",
                title: "Wayside Re-turns (The donkey's path)",
                dimension: '22.5" x 17.5" x 9"',
                material: "Acrylic, glitter, charcoal, gesso, rope, figurine on cardboard, found wood, OSB",
                year: "2024",
            }                        
        ]
    }
]